import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Avatar,
  Button,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Collapse
} from '@mui/material';
import {
  Menu as MenuIcon,
  Home,
  SportsFootball,
  Groups,
  Event,
  Info,
  ContactMail,
  Login,
  PersonAdd,
  Close,
  BusinessCenter,
  HowToReg,
  Handshake,
  ExpandMore,
  ExpandLess
} from '@mui/icons-material';
import KSALogo from '../assets/img/auth/KSA LOGO.jpg';

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorEls, setAnchorEls] = useState({});
  const [mobileOpenItems, setMobileOpenItems] = useState({});
  const location = useLocation();

  const menuItems = [
    { title: 'Home', link: '/auth/departments', icon: <Home /> },
    {
      title: 'About',
      link: '/auth/about',
      icon: <Info />,
      children: [
        { title: 'Our Story', link: '#' },
        { title: 'Our Philosophy', link: '#' },
        { title: 'Facilities', link: '/auth/academy' },
        { title: 'Coaching Staff', link: '#' },
        { title: 'Location / Contact', link: '#' },
      ],
    },
    {
      title: 'Teams',
      link: '/auth/programs',
      icon: <SportsFootball />,
      children: [
        { title: 'Age Groups', link: '#' },
        { title: 'Senior / Pro Pathway', link: '#' },
        { title: 'Girls Academy', link: '#' },
        { title: 'Trial Dates', link: '#' },
        { title: 'School Partnerships', link: '#' },
      ],
    },
    {
      title: 'Players',
      link: '/auth/directory',
      icon: <Groups />,
      children: [
        { title: 'Player Profiles', link: '#' },
        { title: 'Alumni / Pro Players', link: '#' },
        { title: 'Player Welfare', link: '#' },
      ],
    },
    {
      title: 'News & Media',
      link: '#',
      icon: <Event />,
      children: [
        { title: 'Match Reports', link: '#' },
        { title: 'Gallery', link: '#' },
        { title: 'Highlights', link: '#' },
        { title: 'Blog', link: '#' },
      ],
    },
    { title: 'Facility', link: '/auth/academy', icon: <BusinessCenter />, hidden: true },
    {
      title: 'Sponsors',
      link: '#',
      icon: <Handshake />,
      children: [
        { title: 'Our Sponsors', link: '#' },
        { title: 'Become a Sponsor', link: '#' },
        { title: 'Thank You Posts', link: '#' },
      ],
    },
    {
      title: 'Join Us',
      link: '/auth/join',
      icon: <HowToReg />,
      children: [
        { title: 'How to Join', link: '#' },
        { title: 'Scholarships', link: '#' },
        { title: 'Application Form', link: '#' },
        { title: 'FAQs', link: '#' },
      ],
    },
    {
      title: 'Contact',
      link: '/auth/contact',
      icon: <ContactMail />,
      children: [
        { title: 'Phone / WhatsApp / Email', link: '#' },
        { title: 'Contact Form', link: '#' },
        { title: 'Social Media', link: '#' },
      ],
    },
  ];

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDesktopMenuOpen = (title, event) => {
    setAnchorEls((current) => ({
      ...current,
      [title]: event.currentTarget,
    }));
  };

  const handleDesktopMenuClose = (title) => {
    setAnchorEls((current) => ({
      ...current,
      [title]: null,
    }));
  };

  const handleMobileSectionToggle = (title) => {
    setMobileOpenItems((current) => ({
      ...current,
      [title]: !current[title],
    }));
  };

  const drawer = (
    <Box sx={{ width: 280 }} role="presentation">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
        <Avatar src={KSALogo} sx={{ width: 40, height: 40 }} />
        <IconButton onClick={handleDrawerToggle}>
          <Close />
        </IconButton>
      </Box>
      <Divider />
      <List>
        {menuItems.filter((item) => !item.hidden).map((item) => {
          const hasChildren = Array.isArray(item.children) && item.children.length > 0;

          return (
            <React.Fragment key={item.title}>
              <ListItem
                button
                component={hasChildren ? 'div' : Link}
                to={hasChildren ? undefined : item.link}
                onClick={hasChildren ? () => handleMobileSectionToggle(item.title) : handleDrawerToggle}
                selected={!hasChildren && location.pathname === item.link}
                sx={{
                  opacity: 1,
                  '&.Mui-selected': {
                    backgroundColor: 'primary.light',
                    '&:hover': {
                      backgroundColor: 'primary.light',
                    },
                    '& .MuiListItemIcon-root': {
                      color: 'primary.main',
                    },
                    '& .MuiListItemText-primary': {
                      color: 'primary.main',
                      fontWeight: 'bold',
                    },
                  },
                }}
              >
                <ListItemIcon sx={{ color: !hasChildren && location.pathname === item.link ? 'primary.main' : 'inherit' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  sx={{
                    color: !hasChildren && location.pathname === item.link ? 'primary.main' : 'inherit',
                    fontWeight: !hasChildren && location.pathname === item.link ? 'bold' : 'normal'
                  }}
                />
                {hasChildren ? (mobileOpenItems[item.title] ? <ExpandLess /> : <ExpandMore />) : null}
              </ListItem>

              {hasChildren && (
                <Collapse in={Boolean(mobileOpenItems[item.title])} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.children.map((child) => (
                      <ListItem
                        key={child.title}
                        button
                        component={Link}
                        to={child.link}
                        onClick={handleDrawerToggle}
                        sx={{ pl: 5 }}
                      >
                        <ListItemText primary={child.title} />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          );
        })}
        <Divider sx={{ my: 2 }} />
        <ListItem 
          button 
          component={Link} 
          to="/auth/sign-in"
          onClick={handleDrawerToggle}
        >
          <ListItemIcon>
            <Login color="primary" />
          </ListItemIcon>
          <ListItemText primary="Login" />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <AppBar position="fixed" color="default" elevation={2}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Logo for all screens */}
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <Avatar src={KSALogo} sx={{ width: 45, height: 45, mr: 1 }} />
            <Typography
              variant="h6"
              noWrap
              sx={{
                display: { xs: 'none', md: 'flex' },
                fontWeight: 700,
                background: 'linear-gradient(to right, #1976d2, #1565c0)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Kempshot Sports Academy
            </Typography>
          </Box>

          {/* Mobile menu icon */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Desktop menu items */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, gap: 2, ml: 4 }}>
            {menuItems.filter((item) => !item.hidden).map((item) => {
              const hasChildren = Array.isArray(item.children) && item.children.length > 0;

              if (hasChildren) {
                return (
                  <React.Fragment key={item.title}>
                    <Button
                      onClick={(event) => handleDesktopMenuOpen(item.title, event)}
                      endIcon={<ExpandMore />}
                      sx={{
                        color: 'text.primary',
                        fontWeight: 'normal',
                        '&:hover': {
                          color: 'primary.main',
                          backgroundColor: 'primary.light',
                        },
                      }}
                    >
                      {item.title}
                    </Button>
                    <Menu
                      anchorEl={anchorEls[item.title]}
                      open={Boolean(anchorEls[item.title])}
                      onClose={() => handleDesktopMenuClose(item.title)}
                      MenuListProps={{
                        onMouseLeave: () => handleDesktopMenuClose(item.title),
                      }}
                    >
                      {item.children.map((child) => (
                        <MenuItem
                          key={child.title}
                          component={Link}
                          to={child.link}
                          onClick={() => handleDesktopMenuClose(item.title)}
                        >
                          {child.title}
                        </MenuItem>
                      ))}
                    </Menu>
                  </React.Fragment>
                );
              }

              return (
                <Button
                  key={item.title}
                  component={Link}
                  to={item.link}
                  sx={{
                    color: location.pathname === item.link ? 'primary.main' : 'text.primary',
                    fontWeight: location.pathname === item.link ? 'bold' : 'normal',
                    '&:hover': {
                      color: 'primary.main',
                      backgroundColor: 'primary.light',
                    },
                    ...(location.pathname === item.link && {
                      backgroundColor: 'primary.light',
                    })
                  }}
                >
                  {item.title}
                </Button>
              );
            })}
          </Box>

          {/* Desktop action buttons */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
            <Button
              component={Link}
              to="/auth/sign-in"
              variant="outlined"
              color="primary"
              startIcon={<Login />}
            >
              Login
            </Button>
          </Box>
        </Toolbar>
      </Container>

      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better mobile performance
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
};

export default Header; 